import { buildDispatchable } from '../../actions/_action-utilities';
import externalApplicationActions, { syncActions } from '../../actions/external-applications';
import history from '../../history';
export const mapStateToProps = function(state) {
    const { externalApplications } = state;
    const items = externalApplications.externalApplicationList.sortablePageable.pageableDefinition.content;
    const orgId = externalApplications.selectedOrgId || -1;
    return {
        ...externalApplications.externalApplicationList,
        items,
        orgId
    };
};
export const mapDispatchToProps = (dispatch)=>{
    const runDispatchable = buildDispatchable(dispatch);
    return {
        list: (payload)=>{
            runDispatchable(()=>{
                return dispatch(externalApplicationActions.listExternalApps(payload));
            });
        },
        onSelection: (item, path)=>{
            runDispatchable(()=>{
                dispatch(syncActions.selectExternalApplication(item));
                history.push(`${path}/${item.externalApplicationName}`);
            });
        }
    };
};
